import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'
import arrowDown from 'resources/svg/icons/qty-caret-down.svg'

export const Wrapper = styled.div`
  label {
    display: block;
    font: ${font('default', 'normal', '14px/1.5')};
    margin-bottom: 5px;
  }
`

export const ProductQtyWrapper = styled.div`
  display: flex;
  align-items: center;

  input {
    border-radius: 4px;
    height: 40px;
    width: 50px;
    text-align: center;
    border: 1px solid ${(props) => props.theme.palette.general.grey};
    margin: 0;
    box-sizing: content-box;

    &:focus {
      outline: none;
      border-color: ${(props) => props.theme.palette.general.greyDark};
    }
  }

  > div {
    display: inline-block;
    position: relative;
    margin-right: 8px;

    &::after,
    &::before {
      content: '';
      position: absolute;
      right: 2px;
      width: 20px;
      height: 20px;
      pointer-events: none;
      background: #fff url(${arrowDown}) center no-repeat;
      background-size: 12px;
      cursor: pointer;
    }

    &::after {
      margin-top: 2px;
      transform: rotate(180deg);
    }

    &::before {
      margin-bottom: 2px;
      bottom: 0;
    }
  }

  span {
    font-size: 14px;

    small {
      font-size: 14px;
      color: ${(props) => props.theme.palette.primary.alphaDark};
    }
  }
`
